import { useState, MouseEvent } from "react";
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

import "./style.less";

interface IThreeStateToggle {
	value: null | boolean;
	onChange: (newValue: null | boolean) => void;
	title?: string;
	desc?: [string, string, string];
}

export default function ThreeStateToggle({
	value,
	onChange = () => {},
	title = "Popisek",
	desc = ["vlevo", "uprostred", "vpravo"],
}: IThreeStateToggle) {
	const [state, setState] = useState(value === null ? "null" : value.toString());

	function handleAlignment(event: MouseEvent<HTMLElement>, newValue: string) {
		setState(newValue);
		onChange(newValue === "null" ? null : newValue === "true");
	}

	return <div className="threeStateToggle">
		<p className="threeStateToggle__title">
			{ title }
		</p>
		<ToggleButtonGroup
			value={state}
			exclusive
			onChange={handleAlignment}
		>
			<ToggleButton value="false">
				{ desc[0] }
			</ToggleButton>
			<ToggleButton value="null">
				{ desc[1] }
			</ToggleButton>
			<ToggleButton value="true">
				{ desc[2] }
			</ToggleButton>
		</ToggleButtonGroup>
	</div>;
}
